module.exports = __webpack_public_path__ + "static/media/18_plantilla_cuadrada_combo_simple_cp_isotonicas_lata_473_monster_white.f1d05bfa.png";